import { atomWithStorage } from "jotai/utils";

export const browserWarningDismissedAtom = atomWithStorage<boolean>(
  "browserWarningDismissed",
  false,
);
